const normalizePhone = value => String(value || "").replace(/\D/g, "");

export const isWhatsAppInternalIdentifier = value => {
  const name = String(value || "").trim();

  return /^\d{11,20}$/.test(name) || /^\d+@(s\.whatsapp\.net|lid)$/i.test(name);
};

export const getContactDisplayName = contact => {
  const name = String(contact?.name || "").trim();

  if (name && !isWhatsAppInternalIdentifier(name)) return name;

  const number = normalizePhone(contact?.number);
  if (number) return number;

  const identifierNumber = name.includes("@") ? normalizePhone(name.split("@")[0]) : "";
  return identifierNumber || "Contacto sin identificar";
};
